import { Component,OnInit,HostListener,Inject,ViewChild} from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import * as LZString from 'lz-string';

@Component({
  selector: 'app-addclient',
  templateUrl: './addclient.component.html',
  styleUrls: ['./addclient.component.scss']
})
export class AddclientComponent implements OnInit {

  constructor(public _ss:StoreService,public router:Router,public _fb:FormBuilder) { }

  public form:FormGroup

  public Customer

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  ngOnInit(): void {
    
      window.scrollTo(0, 0);

      this.form = this._fb.group({
        CustName:["",Validators.required],
        CustNum:["",Validators.required],
        CustServer:["",Validators.required],
        CustImageDomain:["",Validators.required],

        })

  }

  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  public AddClient(){
    
    this._ss.AddClient({CustName:this.form.controls.CustName.value,CustNum:this.form.controls.CustNum.value,CustServer:this.form.controls.CustServer.value,CustImageDomain:this.form.controls.CustImageDomain.value}).subscribe(
      res=>{
        alert("בוצע בהצלחה")
      },err=>{
        alert("ארעה שגיאה,אנא נסה שנית")
      }
    )
  }
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>
  //=====================================================================================================================================================================================================================================================================>

  public Back(){
    this.router.navigate(['dashbord'])
    }


    
  public burgerMenu
  public headerAbsolute
  public burgerMenuNoScroll
  public showLogoutPopup
  showHideMenu(value: boolean): void {
    this.burgerMenu = value;

    if (value) {
      this.headerAbsolute = value;
      this.burgerMenuNoScroll = value;
    } else {
      setTimeout(() => {
        this.headerAbsolute = value;
        this.burgerMenuNoScroll = value;
      }, 1000);
    }
  }

  showHideLogoutPopup(value: boolean): void {
    this.showLogoutPopup = value;
  }

  
}
